import { ISearchElementStyle } from './searchPageConfig';

// Admin-editor mirror of the shopper bundle-page config
// (ac-storefront-web: Components/Helpers/bundlePageConfig.ts). Persisted as a single JSON string
// on IStorefrontSettings.bundlePageConfig. Each section is a bag of CSS props (ISearchElementStyle)
// applied to a bounding component of the bundle page. Absent config = zero inline styles (strictly additive).
export interface IBundlePageConfig {
    container?: ISearchElementStyle;
    title?: ISearchElementStyle;
    image?: ISearchElementStyle;
    price?: ISearchElementStyle;
    quantity?: ISearchElementStyle;
    includedTable?: ISearchElementStyle;
    addToCartButton?: ISearchElementStyle;
    // The "Add to Cart" text label beside the button (defaults to a white pill with green text).
    addToCartLabel?: ISearchElementStyle;
    description?: ISearchElementStyle;
    // Behavior flag (not a style section): clamp the description with a "Show more" toggle.
    descriptionCollapsible?: boolean;
    // Collapsed height in px used when descriptionCollapsible is true (default 160).
    descriptionCollapsedHeight?: number;
}

export const BUNDLE_PAGE_SECTIONS = [
    'container', 'title', 'image', 'price', 'quantity',
    'includedTable', 'addToCartButton', 'addToCartLabel', 'description',
] as const;

export const DEFAULT_BUNDLE_PAGE_CONFIG: IBundlePageConfig = {};

export function parseBundlePageConfig(raw?: string): IBundlePageConfig {
    if (!raw) return { ...DEFAULT_BUNDLE_PAGE_CONFIG };
    try {
        return { ...DEFAULT_BUNDLE_PAGE_CONFIG, ...(JSON.parse(raw) as IBundlePageConfig) };
    } catch {
        return { ...DEFAULT_BUNDLE_PAGE_CONFIG };
    }
}

export function serializeBundlePageConfig(config: IBundlePageConfig): string {
    return JSON.stringify(config);
}
